import React, { useState } from "react";
import { Modal, Button as Btn, Form, Input, Card, Typography, Tag, message } from "antd";
import Close from "./../../../../assets/icons/close.svg";
import { resetCustomerPassword } from "../../../../api/customer";
import Button from "../../../../components/common/button";
import colors from "../../../../share/constants/constants";

const PasswordResetModal = ({ onCancel, data, onOk, title }) => {
  const [form] = Form.useForm();
  const [inProgress, setInProgress] = useState(false);

  const onFinish = async (value) => {
    setInProgress(true);
    const payload = {
      email: data.email,
      password: value.password,
    };
    const res = await resetCustomerPassword(payload);
    if (res) {
      onOk(payload);
      message.success("Password reset successfully");
      setInProgress(false);
      onCancel();
    }
  };

  const validatePassword = (_, value) => {
    if (!value) {
      return Promise.reject('Password is required');
    }
    if (value.length < 6) {
      return Promise.reject('Password must be at least 6 characters');
    }
    if (!/[A-Z]/.test(value)) {
      return Promise.reject('Password must contain at least one uppercase letter');
    }
    return Promise.resolve();
  };

  return (
    <div>
      <Modal
        open={true}
        footer={null}
        closeIcon={null}
        width="436px"
        onCancel={onCancel}
      >
        <Card>
          <div className="flex">
            <h2 className="flex-1">{title}</h2>
            <img src={Close} alt="Cross Icon" className="w-3.2 cursor-pointer" onClick={() => onCancel()} />
          </div>
          <Form form={form} onFinish={onFinish}>
            <div className="fex flex-col justify-center">
              <div>
                <Typography.Title level={5}>Email</Typography.Title>
                {data?.email}
              </div>
              <Form.Item
                name="password"
                rules={[
                  {validator: validatePassword },
                ]}
              >
                <div>
                  <Typography.Title className="mt-2" level={5}>
                    New Password
                  </Typography.Title>
                  <Input
                    className="flex items-center w-full h-5.4"
                    placeholder={`New Password`}
                    // defaultValue={`${data?.earnedPoints}`}
                  />
                </div>
              </Form.Item>
            </div>
            <Form.Item>
              <Button
                title={"Reset Password"}
                color={colors.primaryPurple}
                className="flex items-center w-full"
                htmlType="submit"
                onOk={onCancel}
                loading={inProgress}
              />
            </Form.Item>
          </Form>
        </Card>
      </Modal>
    </div>
  );
};
export default PasswordResetModal;
